/* 🤖 this file was generated by svg-to-ts */
export const mgcIconDownSmallCuteFi: {
  name: 'down-small-cute-fi';
  data: string;
} = {
  name: 'down-small-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M8.714 9.573c-.605.226-.976.704-1.022 1.319-.03.394.05.651.341 1.093.873 1.33 2.528 2.873 3.367 3.141.352.112.848.112 1.2 0 .837-.268 2.494-1.811 3.364-3.135.304-.463.373-.676.345-1.073-.039-.57-.318-.994-.834-1.264-.196-.104-.252-.113-.635-.114-.369 0-.447.013-.64.104-.283.134-.471.32-.834.829-.323.454-1.258 1.447-1.361 1.447-.065 0-.739-.654-1.037-1.006a9.67 9.67 0 0 1-.391-.519c-.462-.655-.759-.844-1.355-.864-.235-.008-.413.007-.508.042"/></svg>`
};
